export const hdmgdjStats = [
  { id: "s-users", value: "3200万+", label: "累计下载用户" },
  { id: "s-shows", value: "12000+", label: "在架短剧剧目" },
  { id: "s-daily", value: "200+", label: "每日上新剧集" },
  { id: "s-score", value: "4.9", label: "应用商店评分" },
];